import LoadingIcon from "@icons/loadingIcon.svg";

export function Button(props: Props) {
  const { children, loading, ...rest } = props;
  return (
    <button {...(rest as any)}>
      {props.children}
      {props.loading && <LoadingIcon />}
    </button>
  );
}

interface Props extends React.HTMLProps<HTMLButtonElement> {
  loading?: boolean;
}
